<template>
  <div class="min-h-screen bg-carpatina-bg py-12 px-4 animate-fade-in" v-if="produs">
    <div class="max-w-6xl mx-auto">
      
      <div class="flex justify-between items-center mb-8">
<router-link
  :to="{ path: '/produse', query: route.query }"
  class="inline-flex items-center gap-2 text-carpatina-gri font-black uppercase text-xs hover:text-carpatina-portocaliu transition"
>
  <ArrowLeft :size="18" /> Înapoi la catalog
</router-link>

      </div>

      <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        
<div class="space-y-4">
  <div class="bg-white p-4 rounded-[3rem] shadow-2xl border-2 border-white overflow-hidden h-[400px] md:h-[500px] group relative cursor-zoom-in"
       @click="isLightboxOpen = true">
    
    <img :src="'https://carpatinaprodcom.ro/api' + imaginePrincipala" 
         class="w-full h-full object-contain rounded-[2.5rem] transition-transform duration-700 group-hover:scale-105" 
         alt="Produs Carpatina">

    <div class="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center rounded-[2.5rem]">
        <div class="bg-white/90 p-3 rounded-full opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 shadow-lg text-carpatina-portocaliu">
            <ZoomIn :size="24" />
        </div>
    </div>
  </div>

  <div class="flex gap-4 overflow-x-auto pb-2 no-scrollbar" v-if="produs.poze?.length > 1">
    <div v-for="poza in produs.poze" :key="poza.id" 
         @click.stop="imaginePrincipala = poza.url"
         :class="imaginePrincipala === poza.url ? 'border-carpatina-portocaliu ring-2 ring-carpatina-portocaliu ring-offset-2' : 'border-transparent opacity-70 hover:opacity-100'"
         class="w-24 h-24 flex-shrink-0 rounded-2xl overflow-hidden border-2 cursor-pointer transition-all shadow-md bg-white">
      <img :src="'https://carpatinaprodcom.ro/api' + poza.url" class="w-full h-full object-cover">
    </div>
  </div>
</div>

        <div class="bg-white p-8 md:p-12 rounded-[3rem] shadow-2xl border-b-8 border-carpatina-verde space-y-8 relative overflow-hidden">
                  
        <div class="flex items-center gap-2 flex-wrap mb-4 relative z-10">
          <template v-for="(cat, index) in ierarhieCategorii" :key="cat.id">
            
<router-link 
  :to="{
    path: '/produse',
    query: { ...route.query, cat: cat.id, page: 1 }
  }"
  class="bg-gray-100 text-carpatina-gri px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest hover:bg-carpatina-verde hover:text-white transition cursor-pointer"
>
  {{ cat.nume }}
</router-link>

            <ChevronRight v-if="index < ierarhieCategorii.length - 1" :size="12" class="text-gray-300" />
          </template>
        </div>

          <div>
            <h1 class="text-4xl md:text-5xl font-black text-carpatina-gri uppercase mt-4 leading-tight tracking-tighter">
              {{ produs.nume }}
            </h1>
          </div>

          <div class="flex items-center gap-8 border-y border-gray-100 py-6">
            <div v-if="produs.pret" class="text-4xl font-black text-carpatina-verde italic">
              {{ produs.pret }} <span class="text-lg not-italic uppercase font-bold text-gray-400">RON</span>
            </div>
            <div v-else class="text-2xl font-black text-carpatina-portocaliu uppercase italic tracking-tighter">
              Preț la cerere
            </div>
            
            <div :class="produs.stoc ? 'text-green-600 bg-green-50 border-green-200' : 'text-red-500 bg-red-50 border-red-200'" 
                 class="flex items-center gap-2 font-black uppercase text-[10px] px-3 py-1.5 rounded-lg border">
              <div class="w-2 h-2 rounded-full animate-pulse bg-current"></div>
              {{ produs.stoc ? 'În Stoc' : 'Indisponibil' }}
            </div>
          </div>

          <div class="space-y-4">
            <h3 class="font-black uppercase text-carpatina-gri text-sm tracking-widest flex items-center gap-2">
              <FileText :size="18" class="text-carpatina-portocaliu" /> Descriere tehnică
            </h3>
            <div class="text-gray-500 leading-relaxed font-medium text-sm ql-editor-content"
                 v-html="produs.detalii"></div>
          </div>

<div class="pt-6 border-t border-gray-100 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
            
<div v-if="produs.stoc" class="flex items-center bg-gray-50 rounded-2xl border-2 border-gray-100 h-14">
                <button @click="cantitate > 1 && cantitate--" class="w-12 h-full flex items-center justify-center text-gray-500 hover:text-carpatina-portocaliu transition">
                    <Minus :size="16" stroke-width="3" />
                </button>
                <input v-model.number="cantitate" type="number" min="1" class="w-16 text-center text-sm font-black text-carpatina-gri bg-transparent outline-none">
                <button @click="cantitate++" class="w-12 h-full flex items-center justify-center text-gray-500 hover:text-carpatina-portocaliu transition">
                    <Plus :size="16" stroke-width="3" />
                </button>
            </div>
            <button v-if="produs.stoc" 
                    @click="adaugaInCos(produs.id)"
                    :class="adaugatRecent ? 'bg-carpatina-verde' : 'bg-carpatina-portocaliu hover:bg-orange-600'"
                    class="flex-1 text-white h-14 rounded-2xl font-black flex items-center justify-center gap-3 transition-all duration-300 shadow-lg active:scale-95 uppercase tracking-widest text-sm">
              <Check v-if="adaugatRecent" :size="20" class="animate-pulse" />
              <ShoppingCart v-else :size="20" />
              {{ adaugatRecent ? 'Adăugat în Listă' : 'Adaugă în Ofertă' }}
            </button>

            <a v-else href="tel:0247412068" class="flex-1 bg-gray-800 text-white h-14 rounded-2xl font-black flex items-center justify-center gap-2 hover:bg-gray-700 transition shadow-lg uppercase tracking-widest text-sm">
              <PhoneCall :size="18" /> Sună pentru detalii
            </a>

          </div>
        </div>
      </div>

      <div v-if="produseSimilare.length > 0" class="mt-24 border-t border-gray-200 pt-12">
        <h3 class="font-black uppercase text-2xl text-carpatina-gri mb-8 flex items-center gap-3">
            <span class="text-carpatina-portocaliu text-4xl">★</span> Te-ar putea interesa și...
        </h3>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div v-for="sim in produseSimilare" :key="sim.id" class="group bg-white p-4 rounded-[2rem] hover:shadow-xl transition-all duration-300 border border-transparent hover:border-carpatina-verde cursor-pointer relative overflow-hidden">
                <router-link :to="'/produs/' + sim.id">
                    
                    <div class="absolute top-6 left-6 z-10 bg-carpatina-portocaliu/90 backdrop-blur-sm text-white text-[9px] font-black uppercase px-2 py-1 rounded-md shadow-sm tracking-wide">
                        {{ getCategoryName(sim.categorie_id) }}
                    </div>

                    <div class="h-40 overflow-hidden rounded-2xl bg-gray-100 mb-4 relative">
                        <img :src="'https://carpatinaprodcom.ro/api' + (sim.poze[0]?.url || '')" 
                             class="w-full h-full object-cover group-hover:scale-110 transition duration-500"
                             v-if="sim.poze?.length">
                        <div v-else class="w-full h-full flex items-center justify-center text-gray-300 text-xs font-bold uppercase">Fără Poză</div>
                        
                        <div class="absolute bottom-2 right-2 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-lg text-xs font-black text-carpatina-verde shadow-sm" v-if="sim.pret">
                            {{ sim.pret }} Lei
                        </div>
                    </div>
                    
                    <h4 class="font-black text-carpatina-gri uppercase text-sm leading-tight group-hover:text-carpatina-portocaliu transition line-clamp-2">
                        {{ sim.nume }}
                    </h4>
                    <span class="text-[10px] text-gray-400 font-bold mt-2 block uppercase tracking-wide">Vezi Detalii &rarr;</span>
                </router-link>
            </div>
        </div>
      </div>

    </div>
  </div>

  <div v-else class="h-screen flex items-center justify-center bg-carpatina-bg">
    <div class="flex flex-col items-center gap-4">
        <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-carpatina-portocaliu border-gray-200"></div>
        <span class="text-xs font-black uppercase text-gray-400 tracking-widest animate-pulse">Se încarcă produsul...</span>
    </div>
  </div>

<transition enter-active-class="transition duration-300 ease-out"
            enter-from-class="opacity-0 scale-95"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="transition duration-200 ease-in"
            leave-from-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-95">
  
  <div v-if="isLightboxOpen" 
       class="fixed inset-0 z-50 bg-black/95 backdrop-blur-sm flex items-center justify-center p-4 md:p-8"
       @click="isLightboxOpen = false">

      <button class="absolute top-6 right-6 text-white hover:text-red-400 hover:rotate-90 transition-all duration-300 p-2 bg-black/50 hover:bg-white/20 rounded-full backdrop-blur-md z-50">
          <CircleX :size="32" /> 
      </button>

      <img :src="'https://carpatinaprodcom.ro/api' + imaginePrincipala" 
           class="max-w-full max-h-full object-contain rounded-lg shadow-2xl select-none"
           @click.stop> </div>
</transition>

</template>

<script setup>
import { ref, onMounted, watch, inject } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';
import { 
  ArrowLeft, PhoneCall, FileText, ChevronRight, ZoomIn, CircleX, Plus, Minus, ShoppingCart, Check // <--- am adăugat astea noi
} from 'lucide-vue-next';

const route = useRoute();
const produs = ref(null);
const imaginePrincipala = ref('');
const ierarhieCategorii = ref([]);
const produseSimilare = ref([]);
const toateCategoriile = ref([]); // Stocăm toate categoriile pentru a le afișa numele
// În interiorul script setup
const isLightboxOpen = ref(false); // Stare pentru fereastra de zoom
// --- LOGICA PENTRU COȘ ---
const cart = inject('cart');
const cantitate = ref(1); // Cantitatea implicită pentru input
const adaugatRecent = ref(false); // Stare pentru bifa verde

const adaugaInCos = (id) => {
    // Dacă utilizatorul a șters textul din input, forțăm 1
    const qty = parseInt(cantitate.value) || 1;
    
    cart.add(id, qty);
    
    // Animație buton
    adaugatRecent.value = true;
    setTimeout(() => {
        adaugatRecent.value = false;
        cantitate.value = 1; // Resetăm cantitatea după adăugare
    }, 1500);
};
// -------------------------
// Funcție pentru a preveni scroll-ul când e deschis zoom-ul
watch(isLightboxOpen, (val) => {
  if (val) document.body.style.overflow = 'hidden';
  else document.body.style.overflow = '';
});
// Helper pentru nume categorie
const getCategoryName = (id) => {
    const cat = toateCategoriile.value.find(c => c.id === id);
    return cat ? cat.nume : '';
};

// Helper pentru amestecare
const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
};

const fetchProdus = async () => {
  try {
    const [resP, resC] = await Promise.all([
      axios.get('/produse'),
      axios.get('/categorii')
    ]);

    toateCategoriile.value = resC.data; // Salvăm categoriile global în componentă
    const currentId = parseInt(route.params.id);
    const found = resP.data.find(p => p.id === currentId);
    
    if (found) {
      produs.value = found;
      if (found.poze?.length) imaginePrincipala.value = found.poze[0].url;

      // --- LOGICĂ FILTRARE AVANSATĂ ---
      if (found.categorie_id) {
          // 1. Exact Matches (Categorie Identică)
          let exactMatches = resP.data.filter(p => p.categorie_id === found.categorie_id && p.id !== currentId);
          
          // 2. Extended Matches (Părinte / Surori) - Doar dacă e nevoie de umplutură
          let extendedMatches = [];
          const currentCat = resC.data.find(c => c.id === found.categorie_id);
          
          if (currentCat && currentCat.parent_id) {
              const siblingCatIds = resC.data
                  .filter(c => c.parent_id === currentCat.parent_id)
                  .map(c => c.id);
              siblingCatIds.push(currentCat.parent_id);

              extendedMatches = resP.data.filter(p => 
                  siblingCatIds.includes(p.categorie_id) && 
                  p.id !== currentId && 
                  p.categorie_id !== found.categorie_id
              );
          }

          // 3. AMESTECARE & COMBINARE INTELIGENTĂ
          // Amestecăm listele separat
          exactMatches = shuffleArray(exactMatches);
          extendedMatches = shuffleArray(extendedMatches);

          // Combinăm: Exactele primele, apoi restul
          // Astfel, dacă avem produse din aceeași categorie, ele vor fi SIGUR primele.
          produseSimilare.value = [...exactMatches, ...extendedMatches].slice(0, 4);

      } else {
          produseSimilare.value = [];
      }

      // SEO & Breadcrumbs (Logica existentă)
      document.title = `${found.nume} | Carpatina Prodcom`;
      // ... breadcrumbs logic ...
      if (found.categorie_id) {
        let catCurenta = resC.data.find(c => c.id === found.categorie_id);
        const path = [];
        while (catCurenta) {
          path.unshift(catCurenta);
          catCurenta = resC.data.find(c => c.id === catCurenta.parent_id);
        }
        ierarhieCategorii.value = path;
      }
    }
  } catch (err) {
    console.error("Eroare la încărcare detalii", err);
  }
};

onMounted(() => {
    fetchProdus();
    window.scrollTo(0,0);
});

watch(() => route.params.id, () => {
    produs.value = null;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    cantitate.value = 1; // <--- Adăugat asta
    fetchProdus();
});
</script>

<style scoped>
.animate-fade-in { animation: fadeIn 0.6s cubic-bezier(0.22, 1, 0.36, 1); }
@keyframes fadeIn { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
.no-scrollbar::-webkit-scrollbar { display: none; }
</style>